import { MessageStore } from "@/services/models/messageStore";

export interface UnifiedMessage {
  id: number | string;
  from: 'user' | 'assistant' | 'ai';
  content: string;
  timestamp: string;
  images?: string[];
  agent?: string;
  vote?: number;
  
  // Iframe-specific fields
  hasIframe?: boolean;
  iframeContent?: string;
  
  // UI state
  isLoading?: boolean;
}

export function toUnifiedMessage(msg: MessageStore): UnifiedMessage {
  return {
    id: msg.id,
    from: msg.type === 'ai' ? 'assistant' : (msg.type === 'user' ? 'user' : 'ai'),
    content: msg.message,
    timestamp: msg.time,
    images: msg.images,
    agent: msg.agent,
    vote: msg.vote,
    isLoading: msg.isLoading,
  };
}
